module.exports = __webpack_public_path__ + "static/media/activity-content-two.618eb033.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/activity/components/images/activity-content-two.png
// module id = 906
// module chunks = 0